module.exports = __webpack_public_path__ + "img/malaysia.15cd3677.svg";